module.exports = __webpack_public_path__ + "static/media/eye_s.7b5194cf.jpg";